// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"128":"cd038ad475bda42f","911":"1710b46e538ebee5"}[chunkId] + ".js";
};